var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19.019,
    viewBox: "0 0 16 19.019",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Delete_1144250",
    transform: "translate(-23.5 -18.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(23.5 18.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M39.694,30.957l-.55,13.989a.834.834,0,0,1-.8.811h-9.6a.835.835,0,0,1-.8-.811L27.4,30.957a.461.461,0,0,0-.468-.457.467.467,0,0,0-.431.5l.55,13.989a1.76,1.76,0,0,0,1.7,1.725h9.6a1.759,1.759,0,0,0,1.7-1.725L40.592,31a.467.467,0,0,0-.431-.5A.461.461,0,0,0,39.694,30.957Z",
    transform: "translate(-25.546 -27.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M49,36.977V47.784a.477.477,0,0,0,.954,0V36.977a.477.477,0,1,0-.954,0Z",
    transform: "translate(-41.326 -31.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M37.5,36.991,37.818,47.8a.477.477,0,0,0,.953-.028l-.318-10.807a.477.477,0,0,0-.953.028Z",
    transform: "translate(-33.292 -31.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M58.818,36.963,58.5,47.77a.477.477,0,0,0,.953.028l.318-10.807a.477.477,0,0,0-.953-.028Z",
    transform: "translate(-47.98 -31.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M23.953,24.954H39.047a.477.477,0,0,0,0-.954H23.953a.477.477,0,0,0,0,.954Z",
    transform: "translate(-23.5 -22.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M39.493,20.743l.34-.85a.8.8,0,0,1,.647-.439h3.5a.794.794,0,0,1,.647.439l.34.85.885-.354-.34-.85A1.739,1.739,0,0,0,43.977,18.5h-3.5a1.743,1.743,0,0,0-1.533,1.039l-.34.85Z",
    transform: "translate(-34.229 -18.5)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.86e6769c.svg";
export { ForwardRef as ReactComponent };